<template>
  <div>
    <DwPzvipHist />
  </div>
</template>

<script>
  // 获取接口地址
  import DwPzvipHist from '../components/dwPzvip/dwPzvipHis.vue'

  export default {
    name: 'Dwpzvip',
    components: {
      DwPzvipHist
    },
    data() {
      return {}
    },
    created: function() {},
    methods: {}
  }
</script>

<style scoped>
</style>
